// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as Placeholder from "../../resources/layout-and-structure/Placeholder.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as PromotionSheet from "../../modules/Promotion/PromotionSheet.res.js";
import * as PromotionRoutes from "./PromotionRoutes.res.js";
import * as PromotionStatus from "../../modules/Promotion/PromotionStatus.res.js";
import * as TriggerDownload from "../../primitives/TriggerDownload.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as PromotionEditForm from "../../modules/Promotion/PromotionEditForm.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as PromotionStatusBadge from "../../modules/Promotion/PromotionStatusBadge.res.js";
import * as PromotionEdit__Queries from "./PromotionEdit__Queries.res.js";
import * as PromotionEditFormPageActions from "../../modules/Promotion/PromotionEditFormPageActions.res.js";
import * as ReasonMLCommunity__ApolloClient from "rescript-apollo-client/src/ReasonMLCommunity__ApolloClient.res.js";
import * as PromotionEditFormInformationCard from "../../modules/Promotion/PromotionEditFormInformationCard.res.js";
import * as PromotionEditFormManagementTableCard from "../../modules/Promotion/PromotionEditFormManagementTableCard.res.js";
import * as PromotionEditDiscountedProductTableCard from "../../modules/Promotion/PromotionEditDiscountedProductTableCard.res.js";

let PromotionEditPage_InitialValuesError = /* @__PURE__ */Primitive_exceptions.create("PromotionEditPage.Data.PromotionEditPage_InitialValuesError");

function useInitial(cku) {
  let notifier = Notifier.use(undefined, undefined);
  let navigate = Navigation.useNavigate();
  let apolloClient = ReasonMLCommunity__ApolloClient.React.useApolloClient();
  let match = PromotionEdit__Queries.PromotionByCkuQuery.useLazy(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let queryCampaignsResults = match[1];
  let executeCampaignsQuery = match[0];
  let match$1 = React.useState(() => "Loading");
  let setDiscountsStatus = match$1[1];
  let discountsStatus = match$1[0];
  let match$2 = React.useState(() => false);
  let setErrored = match$2[1];
  React.useEffect(() => {
    if (cku !== undefined) {
      executeCampaignsQuery(undefined, undefined, {
        cku: Scalar.CKU.serialize(cku)
      });
    }
  }, [cku]);
  React.useEffect(() => {
    let campaignsData;
    if (queryCampaignsResults.TAG === "Executed") {
      let match = queryCampaignsResults._0;
      let match$1 = match.data;
      if (match$1 !== undefined) {
        campaignsData = match$1.promotionCampaignsByCku;
      } else if (match.error !== undefined) {
        setErrored(param => true);
        campaignsData = undefined;
      } else {
        campaignsData = undefined;
      }
    } else {
      campaignsData = undefined;
    }
    let match$2 = Stdlib_Option.flatMap(campaignsData, param => param.edges[0]);
    if (match$2 !== undefined) {
      let campaign = match$2.node;
      let discountsFetch = after => apolloClient.rescript_query({
        query: PromotionEdit__Queries.PromotionDiscountsQuery.query,
        Raw: PromotionEdit__Queries.PromotionDiscountsQuery.Raw,
        parse: PromotionEdit__Queries.PromotionDiscountsQuery.parse,
        serialize: PromotionEdit__Queries.PromotionDiscountsQuery.serialize,
        serializeVariables: PromotionEdit__Queries.PromotionDiscountsQuery.serializeVariables
      }, undefined, undefined, "NetworkOnly", undefined, PromotionEdit__Queries.PromotionDiscountsQuery.makeVariables(campaign.id, after, PromotionEdit__Queries.PromotionDiscountsQuery.makeInputObjectInputVariantVariantPricesFilter(PromotionEdit__Queries.PromotionDiscountsQuery.makeInputObjectStringEqualsFilter(campaign.price.id, undefined), undefined), undefined));
      PromotionEdit__Queries.runScanDiscounts(discountsFetch, undefined, undefined, result => setDiscountsStatus(param => result), undefined);
    }
  }, [queryCampaignsResults]);
  let data = React.useMemo(() => {
    let exit = 0;
    if (queryCampaignsResults.TAG === "Executed") {
      let match = queryCampaignsResults._0;
      let match$1 = match.data;
      let exit$1 = 0;
      if (match$1 !== undefined) {
        if (typeof discountsStatus === "object") {
          return {
            campaigns: match$1.promotionCampaignsByCku.edges,
            discounts: discountsStatus._0
          };
        }
        exit$1 = 3;
      } else {
        exit$1 = 3;
      }
      if (exit$1 === 3 && match.error === undefined) {
        exit = 2;
      }
    } else {
      exit = 2;
    }
    if (exit === 2) {
      if (typeof discountsStatus === "object") {
        return;
      }
      if (discountsStatus === "Loading") {
        return;
      }
    }
    setErrored(param => true);
  }, [
    queryCampaignsResults,
    discountsStatus
  ]);
  let initialValues = React.useMemo(() => {
    let match = Stdlib_Option.flatMap(data, data => data.campaigns[0]);
    if (data === undefined) {
      return {
        discountedProducts: [],
        name: "",
        priceName: undefined,
        period: undefined,
        rootCampaigns: []
      };
    }
    if (match !== undefined) {
      let campaign = match.node;
      return {
        discountedProducts: data.discounts.map(param => {
          let discount = param.node;
          let match = discount.variant.capacityUnit;
          let match$1 = Stdlib_Option.getOr(discount.variant.bulk, false);
          return {
            id: discount.variant.id,
            cku: discount.variant.cku,
            name: discount.variant.formattedName,
            description: discount.variant.formattedDescription,
            stockKeepingUnit: discount.variant.stockKeepingUnit,
            purchasePrice: Stdlib_Option.getOr(discount.variant.purchasedPrice, 0),
            bulkUnit: match !== undefined && match$1 ? match : undefined,
            retailPrices: discount.variant.variantPrices.edges.map(param => ({
              name: campaign.price.name,
              value: param.node.valueIncludingTax
            })),
            discount: {
              id: discount.id,
              amount: discount.value,
              kind: discount.kind
            }
          };
        }),
        name: campaign.name,
        priceName: campaign.price.name,
        period: [
          campaign.startDate,
          campaign.endDate
        ],
        rootCampaigns: data.campaigns.map(param => {
          let campaign = param.node;
          return {
            id: campaign.id,
            creatorIdentifier: campaign.creatorIdentifier,
            shopId: campaign.shop.id,
            shopName: campaign.shop.name,
            priceId: campaign.price.id,
            status: campaign.formattedStatus,
            selected: true
          };
        })
      };
    }
    throw {
      RE_EXN_ID: PromotionEditPage_InitialValuesError,
      Error: new Error()
    };
  }, [data]);
  let onSubmitSuccess = React.useCallback(submissionResponse => {
    if (submissionResponse !== undefined) {
      if (cku !== undefined) {
        executeCampaignsQuery(undefined, undefined, {
          cku: Scalar.CKU.serialize(submissionResponse)
        });
        return;
      } else {
        return navigate({
          replace: true
        }, PromotionRoutes.showRoute(submissionResponse));
      }
    }
  }, [cku]);
  let onSubmitFailure = React.useCallback(message => notifier.reset({
    TAG: "Error",
    _0: message
  }, undefined, undefined), []);
  let formId = React.useMemo(() => {
    if (Stdlib_Option.isSome(data)) {
      return cku;
    }
  }, [Stdlib_Option.isSome(data)]);
  let match$3 = PromotionEditForm.useFormPropState({
    id: formId,
    initialValues: initialValues,
    schema: PromotionEditForm.schema,
    onSubmitFailure: onSubmitFailure,
    onSubmitSuccess: onSubmitSuccess
  });
  let dispatch = match$3[1];
  let state = match$3[0];
  ReactUpdateEffect.use1(() => {
    if (Stdlib_Option.isSome(cku) && Primitive_object.notequal(initialValues, state.initialValues)) {
      dispatch({
        TAG: "IdAndInitialValuesUpdated",
        _0: cku,
        _1: initialValues
      });
    }
  }, [initialValues]);
  if (match$2[0]) {
    return "Errored";
  } else if (cku !== undefined && data === undefined) {
    return "Loading";
  } else {
    return {
      TAG: "Data",
      _0: {
        form: [
          state,
          dispatch
        ],
        query: data
      }
    };
  }
}

let Data = {
  Queries: undefined,
  PromotionByCkuQuery: undefined,
  PromotionDiscountsQuery: undefined,
  PromotionEditPage_InitialValuesError: PromotionEditPage_InitialValuesError,
  useInitial: useInitial
};

function PromotionEditPage(props) {
  let cku = props.cku;
  let initialData = useInitial(cku);
  let notifier = Notifier.use(undefined, undefined);
  let promotionCreated = Stdlib_Option.isSome(cku);
  let match = React.useState(() => !promotionCreated);
  let setEditing = match[1];
  let editing = match[0];
  let match$1 = Auth.useScope();
  let adminUser;
  adminUser = match$1.TAG === "Organisation";
  let readOnlyShopType = !props.canShopKindEdit;
  let match$2 = Auth.useState();
  let promotionNotCreatedByUser;
  if (typeof match$2 !== "object" || match$2.TAG === "Logging") {
    promotionNotCreatedByUser = promotionCreated;
  } else {
    let user = match$2._0.user;
    promotionNotCreatedByUser = typeof initialData !== "object" ? promotionCreated : initialData._0.form[0].values.rootCampaigns.some(campaign => {
        if (campaign.creatorIdentifier !== user.id) {
          return campaign.status !== undefined;
        } else {
          return false;
        }
      });
  }
  let readOnly = !adminUser && (readOnlyShopType || promotionNotCreatedByUser);
  let onRequestProductsUpdate = React.useCallback(products => {
    if (typeof initialData !== "object") {
      return;
    }
    let match = initialData._0.form;
    if (Primitive_object.notequal(match[0].values.discountedProducts, products)) {
      return match[1]({
        TAG: "FieldValueChanged",
        _0: "DiscountedProducts",
        _1: param => products
      });
    }
  }, [initialData]);
  let onRequestShopsUpdate = React.useCallback(shops => {
    if (typeof initialData !== "object") {
      return;
    }
    if (!editing) {
      return;
    }
    let match = initialData._0.form;
    if (Primitive_object.notequal(match[0].values.rootCampaigns, shops)) {
      return match[1]({
        TAG: "FieldValueChanged",
        _0: "RootCampaigns",
        _1: param => shops
      });
    }
  }, [
    initialData,
    editing
  ]);
  let formattedStatus;
  if (promotionCreated && typeof initialData === "object") {
    let match$3 = initialData._0.query;
    formattedStatus = match$3 !== undefined ? Stdlib_Option.mapOr(match$3.campaigns[0], "DRAFT", param => param.node.formattedStatus) : "DRAFT";
  } else {
    formattedStatus = "DRAFT";
  }
  let onRequestCsvDownload = promotionCampaign => {
    let discounts = promotionCampaign.discountedProducts.map(product => ({
      value: product.discount.amount,
      kind: product.discount.kind,
      variantId: product.id,
      variantStockKeepingUnit: product.stockKeepingUnit
    }));
    let csvBlob = PromotionSheet.makeCsvBlob(discounts);
    if (csvBlob.TAG !== "Ok") {
      return notifier.add({
        TAG: "Error",
        _0: "Something went wrong"
      }, undefined, undefined);
    }
    let match = promotionCampaign.period;
    Future.tapError(TriggerDownload.fromBlob(csvBlob._0, PromotionSheet.makeCsvFilename(promotionCampaign.name, match !== undefined ? match[0] : new Date())), () => notifier.add({
      TAG: "Error",
      _0: "Something went wrong"
    }, undefined, undefined));
  };
  let onRequestExcelDownload = promotionCampaign => {
    let discounts = promotionCampaign.discountedProducts.map(product => ({
      value: product.discount.amount,
      kind: product.discount.kind,
      variantId: product.id,
      variantStockKeepingUnit: product.stockKeepingUnit
    }));
    Future.get(PromotionSheet.makeExcelBlob(discounts), result => {
      if (result.TAG !== "Ok") {
        return notifier.add({
          TAG: "Error",
          _0: "Something went wrong"
        }, undefined, undefined);
      }
      let match = promotionCampaign.period;
      Future.tapError(TriggerDownload.fromBlob(result._0, PromotionSheet.makeExcelFilename(promotionCampaign.name, match !== undefined ? match[0] : new Date())), () => notifier.add({
        TAG: "Error",
        _0: "Something went wrong"
      }, undefined, undefined));
    });
  };
  let renderPageActions = React.useCallback(() => {
    if (readOnly) {
      return null;
    } else {
      return JsxRuntime.jsx(PromotionEditFormPageActions.make, {
        status: formattedStatus,
        promotionCreated: promotionCreated,
        editing: editing,
        onRequestEditing: value => setEditing(param => value),
        onRequestCsvDownload: onRequestCsvDownload,
        onRequestExcelDownload: onRequestExcelDownload
      });
    }
  }, [
    readOnly,
    formattedStatus,
    promotionCreated,
    editing
  ]);
  let renderPageTitleEnd = React.useCallback(() => {
    if (typeof initialData !== "object") {
      return null;
    }
    let match = initialData._0.query;
    if (match !== undefined && promotionCreated && !editing) {
      return Stdlib_Option.mapOr(PromotionStatus.globalFromStatuses(match.campaigns.map(param => param.node.formattedStatus)), null, globalStatus => JsxRuntime.jsx(PromotionStatusBadge.make, {
        status: globalStatus
      }));
    } else {
      return null;
    }
  }, [
    initialData,
    promotionCreated,
    editing
  ]);
  let formattedTitle = promotionCreated ? (
      editing ? (
          typeof initialData !== "object" ? "" : I18n.t("Edition") + " " + I18n.t("Campaign") + " " + initialData._0.form[0].initialValues.name
        ) : (
          typeof initialData !== "object" ? "" : initialData._0.form[0].initialValues.name
        )
    ) : I18n.t("New promotional campaign");
  let editable = formattedStatus === "DRAFT" ? !readOnly : (
      editing && (formattedStatus === "NOT_PROGRAMMED" || formattedStatus === "PROGRAMMED") ? !readOnly : false
    );
  if (typeof initialData !== "object") {
    if (initialData === "Loading") {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Loading"
      });
    } else {
      return JsxRuntime.jsx(Placeholder.make, {
        status: "Error"
      });
    }
  }
  let match$4 = initialData._0.form;
  let state = match$4[0];
  return JsxRuntime.jsx(PromotionEditForm.Core.Provider.make, {
    children: JsxRuntime.jsxs(Page.make, {
      children: [
        JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(Notifier.Banner.make, {
              notifier: notifier
            }),
            JsxRuntime.jsx(PromotionEditDiscountedProductTableCard.make, {
              editable: editable,
              products: state.values.discountedProducts,
              selectedPriceName: state.values.priceName,
              renderPageActions: renderPageActions,
              onRequestProductsUpdate: onRequestProductsUpdate
            }),
            JsxRuntime.jsxs(Group.make, {
              children: [
                JsxRuntime.jsx(PromotionEditFormInformationCard.make, {
                  editable: editable,
                  promotionCreated: promotionCreated
                }),
                JsxRuntime.jsx(PromotionEditFormManagementTableCard.make, {
                  editing: editing,
                  promotionCreated: promotionCreated,
                  campaigns: state.values.rootCampaigns,
                  selectedPriceName: Stdlib_Option.getOr(state.values.priceName, ""),
                  onRequestShopsUpdate: onRequestShopsUpdate
                }, state.values.priceName !== undefined ? Primitive_option.valFromOption(state.values.priceName) : undefined)
              ],
              grid: [
                "30%",
                "70%"
              ],
              wrap: false,
              alignY: "flex-start"
            })
          ],
          space: "medium"
        }),
        null
      ],
      title: formattedTitle,
      renderTitleEnd: renderPageTitleEnd,
      renderActions: renderPageActions
    }),
    propState: [
      state,
      match$4[1]
    ]
  });
}

let make = React.memo(PromotionEditPage);

export {
  Data,
  make,
}
/* make Not a pure module */
